import interceptComment from '@/view/interrogationInfo/intercept'
const intercept = {
    name: 'intercept',
    component: interceptComment,
    meta: {
        title: '提示',

    }
}
export default intercept